import {NgModule} from '@angular/core';
import {CommonModule} from '@angular/common';

import {CloAlert} from './alert';

export {CloAlert} from './alert';
export {CloAlertConfig} from './alert-config';

@NgModule({declarations: [CloAlert], exports: [CloAlert], imports: [CommonModule], entryComponents: [CloAlert]})

export class NgbAlertModule {
}
